import { IntegrityMonitorRuleSetFormWebComponent } from './component/IntegrityMonitorRuleSetFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULE_SET_FORM } from '../../../webcomponents.constants';

export { IntegrityMonitorRuleSetFormWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRITY_MONITOR_RULE_SET_FORM, IntegrityMonitorRuleSetFormWebComponent);
